module.exports = __webpack_public_path__ + "media/choosing_a_college/iStock_000009106215XSmall_max120w-126d771d.jpg";